module.exports = __webpack_public_path__ + "img/view_9.894670fe.jpg";